export const SOFT = 'soft';
export const MEDIUM = 'medium';
export const ACUTE = 'acute';
